/**
 * Interceptor para reescrever URLs do Keycloak que vêm com IP interno
 * Substitui https://139.144.51.105:8443 por https://valedoamanhecer.app.br/login-control
 */

const KC_INTERNAL_URL = 'https://139.144.51.105:8443'
const KC_EXTERNAL_URL = 'https://valedoamanhecer.app.br/login-control'

export const normalizeKeycloakUrl = (url: string): string => {
  if (!url) return url
  
  // Se a URL contém o IP interno, substituir pelo domínio externo
  if (url.includes(KC_INTERNAL_URL)) {
    const normalized = url.replace(KC_INTERNAL_URL, KC_EXTERNAL_URL)
    console.log('[KeycloakUrlInterceptor] Rewritten URL:', url, '->', normalized)
    return normalized
  }
  
  return url
}

// Interceptar o método fetch global para reescrever URLs de resposta do Keycloak
const originalFetch = window.fetch as any

window.fetch = async function(...args: any[]) {
  const response = await originalFetch.apply(window, args)
  
  // Se é uma requisição do openid-configuration, reescrever URLs na resposta
  if (args[0] && args[0].toString().includes('.well-known/openid-configuration')) {
    try {
      const data = await response.clone().json()
      
      // Reescrever todas as URLs que contêm o IP interno
      Object.keys(data).forEach((key) => {
        if (typeof data[key] === 'string' && data[key].includes(KC_INTERNAL_URL)) {
          data[key] = normalizeKeycloakUrl(data[key])
        }
      })

      // Retornar response modificado
      return new Response(JSON.stringify(data), {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
      })
    } catch (e) {
      // Se não conseguir parsear como JSON, retornar response original
      return response
    }
  }

  return response
} as any

console.log('[KeycloakUrlInterceptor] Initialized - Will rewrite Keycloak URLs with internal IP')
